<template>
  <v-container>
    <div
      style="position: relative;"
    >
      <LoadingOverlay
        v-if="loading"
        :loading="loading"
      />

      <DxDataGrid
        :show-borders="false"
        :show-column-headers="false"
        :hover-state-enabled="true"
        height="auto"
        :paging="{ enabled: true, pageSize: itemsPerPage }"
        :pager="{
          showPageSizeSelector: (($route.path === '/news') ? true : false),
          showInfo: (($route.path === '/news') ? true : false),
          visible: (($route.path === '/news') ? true : false),
          allowedPageSizes: [5, 15, 30],
          showNavigationButtons: (($route.path === '/news') ? true : false)
        }"
        :data-source="news"
        no-data-text=""
        @rowClick="openNews"
      >
        <DxColumn
          alignment="left"
          :cell-template="rendercell"
        />
      </DxDataGrid>
    </div>
    <v-dialog v-model="showDetailedNews">
      <v-card v-if="detailedNewsItem">
        <v-card-title class="d-flex flex-column align-start justify-center">
          <v-btn
            icon
            class="align-self-end mb-n8"
            @click="showDetailedNews = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <h3 class="text-h5">
            {{ detailedNewsItem.TITLE }}
          </h3>
          <div class="text-subtitle-1">
            {{ detailedNewsItem.NEWS_DATE }}
          </div>
        </v-card-title>
        <v-divider class="mb-4" />
        <v-card-text v-html="$sanitizeHtml(detailedNewsItem.TEXT)" />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid'
import LoadingOverlay from '@/components/LoadingOverlay'
import axios from 'axios'

export default {
  components: {
    DxDataGrid,
    DxColumn,
    LoadingOverlay
  },
  data: () => ({
    news: [],
    itemsPerPage: 5,
    showDetailedNews: false,
    detailedNewsItemIndex: -1,
    loading: true
  }),
  computed: {
    detailedNewsItem () {
      return this.detailedNewsItemIndex !== -1
        ? this.news[this.detailedNewsItemIndex]
        : null
    }
  },
  created () {
    this.fetchNews()
  },
  methods: {
    openNews ({ data }) {
      this.detailedNewsItemIndex = this.news.indexOf(data)
      this.showDetailedNews = true
    },
    async fetchNews () {
      if (this.$route.path === '/news') {
        const response = await axios.get(
          this.$store.state.host + '/proteomicsdb/logic/getNews.xsjs'
        )
        this.news = response.data.allNews
      } else {
        const response = await axios.get(
          this.$store.state.host + '/proteomicsdb/logic/getNews.xsjs', {
            params: { top: 5 }
          }
        )
        this.news = response.data.allNews
      }
      this.loading = false
    },
    rendercell (cellElement, cellInfo) {
      const data = cellInfo.data
      const container = document.createElement('div')
      container.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <div>
        <div class="font-weight-light">${data.NEWS_DATE}</div>
        <div class="font-weight-bold">${data.SHORT_TITLE}</div>
        <div>${data.SHORT_TEXT}</div>
      </div>
      <div style="background-color: #F5F5F5;padding:10px 20px;font-size:0.875rem;font-weight: 500;border-radius:4px;" onmouseover="this.style.backgroundColor='#E0E0E0'" onmouseout="this.style.backgroundColor='#F5F5F5';">Read more</div>
    </div>
  `
      return container
    }
  }
}
</script>
